import * as React from 'react';
import { ca } from '@cian/analytics';
/**
 * Разметка: https://conf.cian.tech/pages/viewpage.action?pageId=1413840548
 */
export function useTracking(_ref) {
  let {
    newbuildingId,
    pageTypeJK,
    houseId
  } = _ref;
  const page = React.useMemo(() => {
    const isSeoPage = pageTypeJK === 'Seo';
    const extra = {
      PageTypeJK: 'Normal'
    };
    if (isSeoPage) {
      extra.is_seo = true;
    }
    return {
      pageType: 'CardJK',
      siteType: 'mobile',
      extra
    };
  }, [pageTypeJK]);

  /**
   * Старое событие, в статье не отсутствует, используется только в флоу с отключенной модалкой офферов
   */
  const trackListingLinkClick = React.useCallback(action => {
    ca('eventSite', {
      name: 'oldevent',
      category: 'Card_JK',
      action,
      label: 'layout',
      page,
      products: [{
        id: newbuildingId,
        offerType: 'JK',
        extra: {
          room_num: null,
          corpus_id: houseId || null
        }
      }]
    });
  }, [page, newbuildingId, houseId]);

  /**
   * Событие открытия модалки офферов (№2)
   */
  const trackLayoutModalOpen = React.useCallback(() => {
    ca('eventSite', {
      name: 'oldevent',
      category: 'Layout',
      action: 'show_sopr',
      label: 'modal_open',
      page,
      products: [{
        id: newbuildingId,
        offerType: 'JK'
      }]
    });
  }, [page, newbuildingId]);

  /**
   * Старое событие перехода по ссылке на 3D тур, в статье отсутствует
   */
  const trackTourClick = React.useCallback(() => {
    ca('eventSite', {
      name: 'oldevent',
      category: 'Layouts',
      action: 'Сlick',
      label: '3dtour_viewer',
      page,
      products: [{
        id: newbuildingId,
        offerType: 'JK'
      }]
    });
  }, [page, newbuildingId]);

  /**
   * Событие перехода в карточку объекта из модалки офферов (№3)
   */
  const trackFlatCardClick = React.useCallback(() => {
    ca('eventSite', {
      name: 'oldevent',
      category: 'Layout',
      action: 'click_sopr',
      label: 'modal_open_card',
      page,
      products: [{
        id: newbuildingId,
        offerType: 'JK'
      }]
    });
  }, [page, newbuildingId]);

  /**
   * Событие перехода из модалки листинг внутри ЖК (№4)
   */
  const trackHeaderLinkClick = React.useCallback(() => {
    ca('eventSite', {
      name: 'oldevent',
      category: 'Layout',
      action: 'click_sopr',
      label: 'modal_open_listing_jk',
      page,
      products: [{
        id: newbuildingId,
        offerType: 'JK'
      }]
    });
  }, [page, newbuildingId]);
  return React.useMemo(() => ({
    trackListingLinkClick,
    trackLayoutModalOpen,
    trackFlatCardClick,
    trackHeaderLinkClick,
    trackTourClick
  }), [trackListingLinkClick, trackLayoutModalOpen, trackTourClick, trackFlatCardClick, trackHeaderLinkClick]);
}